import { render } from "./GuidanceSection.vue?vue&type=template&id=b4588948&scoped=true"
import script from "./GuidanceSection.vue?vue&type=script&lang=js"
export * from "./GuidanceSection.vue?vue&type=script&lang=js"

import "./GuidanceSection.vue?vue&type=style&index=0&id=b4588948&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4588948"]])

export default __exports__